// extracted by css-extract-rspack-plugin
export default {"UpsellBannerOcticon":"UpsellBanner-module__UpsellBannerOcticon__YbeEHGy","UpsellBannerHeading":"UpsellBanner-module__UpsellBannerHeading__up_fyQh"};